export enum Environment {
  PRODUCTION = 'production',
  STAGE = 'stage',
  STAGE2 = 'stage2',
  STAGE3 = 'stage3',
  STAGE4 = 'stage4',
  DEVELOPMENT = 'development',
}

export interface EnvironmentVariables {
  DEBUG: boolean;
  NODE_ENV: string;
  WEB_APP_ENABLE_SW: boolean;
  ANALYTICS_ENABLED: boolean;
  PLATFORM_API_PUBLIC: string;
  HERMES_PUBLIC_URL: string;
  ALMANAC_PUBLIC_URL: string;
  BELL_PUBLIC_URL: string;
  DOMAIN: string;
  CDN_DOMAIN: string;
  STRIPE_API_TOKEN: string;
  FACEBOOK_CLIENT_ID: string;
  FACEBOOK_CLIENT_TOKEN: string;
  FACEBOOK_APP_ID: string;
  FACEBOOK_DOMAIN_VERIFICATION: string;
  GOOGLE_CLIENT_ID: string;
  ADYEN_HOSTNAME: string;
  GOOGLE_MAPS_KEY: string;
  GOOGLE_TRANSLATE_TOKEN: string;
  GOOGLE_OPTIMIZE_ID: string;
  LANGUAGE_DETECTION_URL: string;
  RUDDERSTACK_WRITE_KEY: string;
  RUDDERSTACK_DATA_PLANE_URL: string;
  RUDDERSTACK_CDN: string;
  RUDDERSTACK_SOURCE_CONFIG: string;
  ALGOLIA_APP_ID: string;
  ALGOLIA_INDEX_NAME: string;
  ALGOLIA_INDEX_NAME_NEXT: string;
  ALGOLIA_INDEX_LOW_TO_HIGH: string;
  ALGOLIA_INDEX_HIGH_TO_LOW: string;
  ALGOLIA_INDEX_MOST_RECENT: string;
  ALGOLIA_INDEX_CHARITABLE: string;
  ALGOLIA_API_KEY: string;
  IMMOBILIARE_MAPS_KEY: string;
  GOOGLE_TAG_MANAGER_ID: string;
  GOOGLE_TRACKING_ID: string;
  BUGSNAG_KEY: string;
  OSIRIS_URL: string;
  OSIRIS_PUBLIC_URL: string;
  METIS_URL: string;
  HA_THUMB_IMAGE_TIMEOUT_MS: number;
  MEDIA_QUERY_NEXT: boolean;
  // Key to enable/disable SplitIO completely
  SPLIT_ENABLED: boolean;
  // Check the link for detailed explanation of these configurations
  // https://help.split.io/hc/en-us/articles/360020564931w#configuration
  SPLIT_API_KEY: string;
  // core.labelsEnabled
  SPLIT_LABELS_ENABLED: boolean;
  // startup.retriesOnFailureBeforeReady
  SPLIT_RETRIES_ON_FAILURES_BEFORE_READY: number;
  // startup.readyTimeout
  SPLIT_READY_TIMEOUT: number;
  // The path to the file with the mocked split data.
  // https://help.split.io/hc/en-us/articles/360020564931-Node-js-SDK#localhost-mode
  SPLIT_LOCALHOST_FEATURES: string;
  RECAPTCHA_V2_INVISIBLE_KEY: string;
  // The URL of the Imgix source for this environment
  // https://dashboard.imgix.com/sources
  IMGIX_SOURCE_URL: string;
  CHEQ_ENABLED: boolean;
  STUDAPART_ADVERTISER_ID?: number;
  AVUXI_KEY: string;
  // Enables the integration with the Identity Platform
  AUTH_ENABLED: boolean;
  // Support for RMS <-> Tokamak redirects
  RMS_BASE_DOMAIN: string;
  // Cookies banner provider
  ONETRUST_DOMAIN_KEY: string;
  // Customer Support chat
  INTERCOM_APP_ID: string;
  // Sentry DSN
  SENTRY_DSN_REACT: string;
  SENTRY_DSN_NODE: string;
  SENTRY_ENABLED: boolean;
  SENTRY_DEBUG: boolean;
  SENTRY_TRACES_SAMPLE_RATE: number;
  SENTRY_SAMPLE_RATE: number;
  SENTRY_NORMALIZE_DEPTH: number;
}
